// @flow @jsx h
import { h, Component } from 'preact'
import styles from './App.css'
import { PartyColumn } from './PartyColumn'

import type { SurveyMetadata, PoliticalParty } from './types'
import { bem } from '@nrk/dh-utils'
import { getWidthAsText } from './lib/getWidthAsText'
import { prettyPrintNumber } from '../helpers/prettyPrintNumber'

type Props = {
  title: string,
  surveyMetadata: SurveyMetadata,
  politicalParties: Array<PoliticalParty>,
}

type State = {
  containerWidth?: number
}

export class App extends Component<Props, State> {
  element: HTMLDivElement

  componentDidMount () {
    this.setState({ containerWidth: this.element.offsetWidth })
    window.addEventListener('resize', this.resizeHandler)
    window.addEventListener('orientationchange', this.resizeHandler)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.resizeHandler)
    window.removeEventListener('orientationchange', this.resizeHandler)
  }

  resizeHandler = () => {
    this.setState({
      containerWidth: this.element.offsetWidth
    })
  }

  render () {
    const { title, surveyMetadata, politicalParties } = this.props
    const { containerWidth } = this.state
    const previousValues = politicalParties.map(party => party.previousPeriod)
    const currentValues = politicalParties.map(party => party.currentPeriod)
    const maxValue = Math.max(...previousValues.concat(currentValues))
    const widthAsText = getWidthAsText(containerWidth)

    return (
      <div ref={(el) => {
        this.element = el
      }} className={styles.withComparison}>
        <header className={styles.withComparison__header}>
          <h1 className={styles.withComparison__title}>{title}</h1>
          <div className={styles.withComparison__description}>{createDescription(surveyMetadata)}</div>
        </header>
        <div className={bem(
          styles.withComparison__columnHeaders,
          widthAsText
        )} aria-hidden='true'>
          <div className={styles.withComparison__header__party}>Parti</div>
          <div className={styles.withComparison__header__diff}>Endring</div>
        </div>
        <div className={bem(
          styles.withComparison__partyColumns,
          widthAsText
        )}>
          { politicalParties.map(party => (
            <PartyColumn
              key={party.nameShort}
              containerWidth={containerWidth}
              politicalParty={party}
              maxValue={maxValue} />
          )) }
        </div>
        <div className={styles.withComparison__source}>Kilde: {surveyMetadata.source}</div>
      </div>
    )
  }
}

function createDescription (surveyMetadata: SurveyMetadata): string {
  const { startDate, endDate, interviewCount, errorMarginLowest, errorMarginLargest } = surveyMetadata
  if (startDate && endDate && interviewCount && interviewCount && errorMarginLowest && errorMarginLargest) {
    return `Periode ${startDate}–${endDate}. ${interviewCount} intervjuer. Feilmarginer fra ${prettyPrintNumber(errorMarginLowest)}–${prettyPrintNumber(errorMarginLargest)} pp.`
  } else {
    return null
  }

}



// WEBPACK FOOTER //
// ./src/v2/components/withComparison/App.js